import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { Dimmer, Grid, Button } from 'semantic-ui-react';
import ProfileContactDetails from './profile-contact-details';
import ProfilePayments from './profile-payments';
import ProfileApiData from './profile-api-data';
import ProfileBios from './profile-bios';
import ProfileSocialDetails from './profile-social-details';
import ProfileTags from './profile-tags';
import ProfileBusinessUnits from './profile-business-units';
import ProfilePlatformData from './profile-platform-data';
import ProfileDescription from './profile-description';
import ProfileDemographics from './profile-demographics';
import { loadSingleInfluencer } from '../influencers/actions';
import { authService } from '../../utils/auth-service';
import { reportError } from '../../utils/error-handling-service';
import CreatorLinkGenerator from '../../components/creator-link-generator';

class InfluencerProfile extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    onLoadSingleInfluencer: PropTypes.func.isRequired,
    influencer: PropTypes.object,
    loading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    influencer: {},
    organisationName: '',
  };

  constructor() {
    super();
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 5000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  onInfluencerPatch = (id, patch) => {
    const requestData = { data: { attributes: patch } };
    this.restClient.patch(`/influencer/${id}`, requestData).then(r => r.data).catch(e => {
      reportError('Can not patch influencer', e);
    });
  }


  render() {
    const { influencer, influencerDetails, children: { onReloadDetails, onInfluencerUpdated } } = this.props;
    const { influencerApiLink } = influencer;

    return (
      <div className="page">
        { influencer &&
        <Dimmer.Dimmable>
          <div className="page-content">
            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  <ProfileContactDetails
                    influencer={influencer}
                    onInfluencerPatch={this.onInfluencerPatch}
                    afterUpdate={this.loadInfluencer}
                  />
                  <ProfileDemographics influencer={influencer} />
                  <ProfilePayments
                    influencer={influencer}
                  />
                  <ProfileDescription influencerDetails={influencerDetails} />
                  <CreatorLinkGenerator {...influencer} />
                </Grid.Column>
                <Grid.Column width={8}>
                  <ProfileSocialDetails influencer={influencer} onSaved={onInfluencerUpdated} />
                  <ProfileTags onReloadDetails={onReloadDetails} influencer={influencer} details={influencerDetails} />
                  <ProfileBusinessUnits onReloadDetails={onReloadDetails} influencer={influencer} details={influencerDetails} />
                  <ProfilePlatformData influencer={influencer} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Dimmer.Dimmable>
        }
      </div>
    );
  }
}


export function mapDispatchToProps(dispatch) {
  return {
    onLoadSingleInfluencer: id => dispatch(loadSingleInfluencer(id)),
    dispatch,
  };
}

export default InfluencerProfile;



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-profile/index.js
 **/